module.exports = __webpack_public_path__ + "media/images/tunnel/sabrina-06504517a09e30506f5ebc21208eb70e.jpg";